import { render, staticRenderFns } from "./expiredTable.vue?vue&type=template&id=1e558800&"
import script from "./expiredTable.vue?vue&type=script&lang=js&"
export * from "./expiredTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports